<template>
  <!-- display: contents makes children become grid items of the parent grid -->
  <div class="contents">
    <!-- Start select sits in the first available column (col 5 in your header) -->
    <div class="justify-self-start w-28 sm:w-32 md:w-40 max-w-full">
      <select
        class="w-full text-[11px] rounded-md border px-2 py-1 whitespace-nowrap"
        :value="sel.startKey"
        aria-label="Start date field"
        @change="updateStart"
      >
        <option
          v-for="opt in startOptions"
          :key="opt.key"
          :value="opt.key"
        >
          {{ opt.label }}
        </option>
      </select>
    </div>

    <!-- End select sits in the next column (col 6 in your header) -->
    <div class="justify-self-start w-28 sm:w-32 md:w-40 max-w-full">
      <select
        class="w-full text-[11px] rounded-md border px-2 py-1 whitespace-nowrap"
        :value="sel.endKey"
        aria-label="End date field"
        @change="updateEnd"
      >
        <option
          v-for="opt in endOptions"
          :key="opt.key"
          :value="opt.key"
        >
          {{ opt.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useProjectManagementStore } from '@/pinia/projectManagementStore'

const props = defineProps({
  jobId: { type: [Number, String], required: true }
})

const startOptions = [
  { key: 'date_commenced',            label: 'Commenced' },
  { key: 'date_planned_start',        label: 'Planned Start' },
  { key: 'date_fixed_start',          label: 'Fixed Start' },
  { key: 'date_targeted_start',       label: 'Targeted Start' },
  { key: 'date_predicted_start',      label: 'Predicted Start' },
  { key: 'date_user_estimated_start', label: 'User-Estimated Start' }
]

const endOptions = [
  { key: 'date_completed',          label: 'Completed' },
  { key: 'date_planned_due',        label: 'Planned Due' },
  { key: 'date_fixed_due',          label: 'Fixed Due' },
  { key: 'date_targeted_due',       label: 'Targeted Due' },
  { key: 'date_predicted_due',      label: 'Predicted Due' },
  { key: 'date_user_estimated_due', label: 'User-Estimated Due' }
]

const pm = useProjectManagementStore()
const jobIdNum = computed(() => Number(props.jobId))
const sel = computed(() => pm.scheduleFieldsForJob(jobIdNum.value))

function updateStart(e) {
  pm.setScheduleFieldsForJob(jobIdNum.value, e.target.value, undefined)
}
function updateEnd(e) {
  pm.setScheduleFieldsForJob(jobIdNum.value, undefined, e.target.value)
}
</script>
